import React from 'react';
import cn from 'classnames';
import { Link } from 'react-router-dom';

import { LOGIN } from 'routers/route-path';
import { useBranding } from 'hooks/useBranding';
import { getLogoComponent } from 'utilities/common';

const Logo = ({ className = '', to = LOGIN }) => {
  const { branding } = useBranding();
  const LogoComponent = getLogoComponent(branding?.logoFull);

  return (
    <div className={cn('t-center', className)}>
      <Link to={to}>
        <LogoComponent />
      </Link>
    </div>
  );
};

export default Logo;
